import { useEffect, useState } from 'react'
import { useToast } from "@/hooks/use-toast"
import { ToastAction } from "@/components/ui/toast"

import { listenToCollection, markNotificationAsRead } from './service'

const Notifications = () => {
  const { toast } = useToast()
  const [lastUnreadNotificationId, setLastUnreadNotificationId] = useState(null)

  useEffect(() => {
    const unsubscribe = listenToCollection('notifications', (userNotifications) => {
      const unreadNotifications = userNotifications.filter(userNotification => !userNotification.read)
      const latestNotification = unreadNotifications[0]

      if (latestNotification) {
        toast({
          title: latestNotification?.value,
          description: latestNotification?.message,
          duration: 500000000000000,
          action: (
            <ToastAction
              altText="Mark as read"
              onClick={() => handleNotificationClick(latestNotification?.id)}
            >
              Mark as read
            </ToastAction>
          ),
        })
      }
    }, { read: false })

    return () => unsubscribe()
  }, [lastUnreadNotificationId])

  const handleNotificationClick = async (notificationId) => {
    await markNotificationAsRead(notificationId)
  }

  return null
}

export default Notifications
